import { LoaderMask } from 'components/LoaderMask/LoaderMask';
import { useAsyncEffect } from 'customHooks/hooks';
import React, { ReactElement, useContext } from 'react';
import { WidgetGeneratorContext } from 'screens/WidgetGenerator/contexts/WidgetGeneratorContext';
import { BenchmarkGenericQuestionsTable } from 'screens/WidgetGenerator/widgets/BenchmarkWidgets/BenchmarkGenericQuestionsTable/BenchmarkGenericQuestionsTable';
import { fetchBenchmarkCycleExecutions } from 'services/benchmarkCycleExecutions';
import { fetchBenchmarkGenericQuestionScores } from 'services/benchmarkScores';
import { logger } from 'utils/logger';
import { AspectValues } from 'types/aspect';
import classNames from 'classnames';
import { SurveysReportGeneratorFilterKey } from 'screens/WidgetGenerator/reportGeneratorComponents/enums';
import { ReportBuilderComponentProps } from '../WidgetWrappers/WidgetWrappers';
import styles from './BenchmarkGenericQuestionsTableHOC.module.scss';

export const BenchmarkGenericQuestionsTableHOC = (props: ReportBuilderComponentProps): ReactElement => {
  const { client } = useContext(WidgetGeneratorContext);
  const selectedBenchmarkClient = client;

  const { params } = props;
  const { filters } = params;
  const selectedAspect = filters[SurveysReportGeneratorFilterKey.BENCHMARK_ASPECT_SELECT];
  const selectedAspectValue = selectedAspect?.value;

  const fetchBenchmarkTableWidgetData = async () => {
    if (!selectedBenchmarkClient) {
      return null;
    }

    const fetchedBenchmarkCycles = await fetchBenchmarkCycleExecutions();
    const parsedBenchmarkCycles = fetchedBenchmarkCycles.map((benchmarkCycle) => ({
      startDate: benchmarkCycle.start_date,
      endDate: benchmarkCycle.end_date,
      value: benchmarkCycle.id.toString(),
    }));

    const selectedDateRange = parsedBenchmarkCycles[0];

    const fetchedData = await fetchBenchmarkGenericQuestionScores(selectedBenchmarkClient, selectedDateRange);
    return fetchedData;
  };

  const {
    fetchedData: benchmarkTableData,
    isLoading,
    error,
  } = useAsyncEffect(fetchBenchmarkTableWidgetData, [selectedBenchmarkClient]);

  if (error) {
    logger.error(error);
  }

  if (!benchmarkTableData) {
    return <></>;
  }

  return (
    <LoaderMask isLoading={isLoading}>
      <div
        className={classNames({
          [styles.characteristicTable]: selectedAspectValue === AspectValues.CHARACTERISTIC,
        })}
      >
        <BenchmarkGenericQuestionsTable widgetData={benchmarkTableData} selectedAspect={selectedAspectValue} />
      </div>
    </LoaderMask>
  );
};
